export const ROW_DETAILS_HEIGHT = 150;
export const DIMENSION_MIN_WIDTH = 131;
export const METRIC_MIN_WIDTH = 118;
